/* eslint-disable prefer-const */
import invert from 'invert-color'

const TwoPI = Math.PI * 2
const percent = 0.06283185307

export default class PChart {
  constructor (canvas, radius, innerRadius, parts) {
    const self = this
    self.canvas = canvas
    self.context = self.canvas.getContext('2d')
    self.rect = self.canvas.getBoundingClientRect()
    self.radius = radius
    self.innerRadius = innerRadius
    for (let i = 0; i < parts.length; i++) {
      parts[i].fontColor = invert(parts[i].color, true)
      parts[i].startingAngle = undefined
      parts[i].endingAngle = undefined
      parts[i].hHovered = false
      parts[i].hX = undefined
      parts[i].hY = undefined
      parts[i].hRad = undefined
      parts[i].hiHovered = false
      parts[i].hiX = undefined
      parts[i].hiY = undefined
      parts[i].hiRad = undefined
    }
    self.parts = parts
    self.draggedPart = undefined
    self.ReDraw(true)
  }

  centerX () {
    const self = this
    return Math.floor(self.canvas.width / 2)
  }

  centerY () {
    const self = this
    return Math.floor(self.canvas.height / 2)
  }

  PolarToCartesian (angle, radius) {
    return {
      x: radius * Math.cos(angle),
      y: radius * Math.sin(angle)
    }
  }

  GetGeometry () {
    const self = this
    // const centerX = Math.floor(self.canvas.width / 2)
    // const centerY = Math.floor(self.canvas.height / 2)
    return {
      centerX: self.centerX(),
      centerY: self.centerY(),
      radius: Math.min(self.centerX(), self.centerY()) * self.radius
    }
  }

  IsTouchDevice () {
    // works on most browsers && // works on IE10/11 and Surface
    return 'ontouchstart' in window || navigator.maxTouchPoints
  }

  ReDraw (init = false) {
    const self = this
    self.ClearAll()

    self.DrawCircle(self.radius)
    for (let i = 0; i < self.parts.length; i = i + 1) {
      const currentItem = self.parts[i]
      const currentPercent = currentItem.percent
      const currentColor = currentItem.color
      if (init) {
        const previousPercent = self.parts.map(r => r.percent).reduce((total, currentValue, currentIndex) => {
          if (currentIndex < i) {
            return total + currentValue
          } else {
            return total
          }
        }, 0)
        currentItem.startingAngle = percent * previousPercent
        currentItem.endingAngle = percent * (previousPercent + currentPercent)
      } else {
        if (currentItem.startingAngle < 0) {
          currentItem.startingAngle = TwoPI + currentItem.startingAngle
        }

        let diff = currentItem.endingAngle - currentItem.startingAngle
        if (diff < 0) {
          diff = diff + TwoPI
        }
        currentItem.percent = parseFloat((diff / percent).toFixed(2))
      }
      // const label = `${currentItem.id}(${currentPercent.toFixed(2)}%)`
      const label = `${currentPercent}%`
      self.DrawSlice(self.radius, currentItem.startingAngle, currentItem.endingAngle, currentColor, currentItem.fontColor, label)
    }
    self.parts.map(r => self.DrawText(r))
    self.parts.map(r => self.DrawHandle(r.id, r.hHovered))
    self.DrawCircle(self.innerRadius)
    self.parts.map(r => self.DrawMovingHandle(r.id, self.radius, r.hiHovered))
  }

  DrawSlice (radius, startingAngle, endingAngle, color, fontColor, label = 'test') {
    const self = this

    // Draw coloured segment
    self.context.save()
    // const prev = self.context.lineWidth
    self.context.lineWidth = 10
    self.context.beginPath()
    self.context.moveTo(self.centerX(), self.centerY())

    self.context.arc(self.centerX(), self.centerY(), radius, startingAngle, endingAngle, false)

    self.context.closePath()

    self.context.fillStyle = color
    self.context.fill()
    // // self.context.restore()
    // self.context.lineWidth = prev
    // // Draw label on top
    // // self.context.save()
    // self.context.translate(self.centerX(), self.centerY())
    // self.context.rotate(startingAngle)
    //
    // const fontSize = Math.floor(self.context.canvas.height / 30)
    // const dx = radius - fontSize
    // const dy = self.centerY() / 10
    //
    // self.context.textAlign = 'right'
    // self.context.font = fontSize + 'px Verdana'// 'pt Courier New bold'
    // self.context.fillStyle = fontColor
    // self.context.fillText(label, dx, dy)

    self.context.restore()
  }

  DrawText (part) {
    const self = this

    const fontSize = Math.floor(self.context.canvas.height / 30)
    let start = part.startingAngle
    let end = part.endingAngle

    if (end < start) {
      end = end + TwoPI
    }

    let diff = end - start
    if (diff < 0) {
      diff = diff + TwoPI
    }

    const currentPercent = diff / percent
    const Is100 = currentPercent === 100
    // const L1 = 0
    const L2 = parseFloat((TwoPI / 4).toFixed(5))
    // const L3 = parseFloat((TwoPI / 2).toFixed(5))
    const L4 = parseFloat((TwoPI * 3 / 4).toFixed(5))

    const half = Math.abs((end - start) / 2)
    let angle1 = part.startingAngle + half
    angle1 = self.Corrected(angle1)

    const K = parseFloat(parseFloat(JSON.stringify(angle1)).toFixed(5))
    const IsRotateNeeded = Is100 || (K >= L2 && K <= L4)

    self.context.save()
    self.context.textAlign = 'right'
    self.context.font = fontSize + 'px Verdana'// 'pt Courier New bold'
    self.context.fillStyle = part.fontColor

    self.context.translate(self.centerX(), self.centerY())
    const newTitle = `${part.title} ${currentPercent.toFixed(0)}%`
    // const newTitle = part.title

    if (IsRotateNeeded) {
      self.context.rotate(angle1 + TwoPI / 2)
      // self.context.fillText(newTitle, self.radius / -1.8, 0)
      self.context.fillText(newTitle, self.radius / -3, 0)
    } else {
      self.context.rotate(angle1)
      // self.context.fillText(newTitle, self.radius / 1.2, 0)
      self.context.fillText(newTitle, self.radius / 1.1, 0)
    }
    self.context.restore()
  }

  DrawHandle (id, hover) {
    const self = this
    const part = self.parts.find(r => r.id === id)
    if (part !== undefined) {
      let next = self.parts.find(r => r.id === id + 1)
      if (next === undefined) {
        next = self.parts[0]
      }

      const radius = hover ? 7 : 5
      const location = self.PolarToCartesian(part.endingAngle, self.radius)
      const Z1 = self.PolarToCartesian(part.endingAngle, self.radius + radius)
      const Z2 = self.PolarToCartesian(part.endingAngle, self.radius - radius)

      self.context.save()
      self.context.translate(self.centerX(), self.centerY())
      self.context.fillStyle = part.color // hover ? '#35ae4c' : part.color

      self.context.beginPath()
      self.context.arc(location.x, location.y, radius, part.endingAngle, part.endingAngle + TwoPI / 2, true)
      self.context.fill()
      self.context.stroke()
      self.context.restore()

      self.context.save()
      self.context.translate(self.centerX(), self.centerY())
      self.context.fillStyle = next.color // hover ? '#35ae4c' : part.color

      self.context.beginPath()
      self.context.arc(location.x, location.y, radius, part.endingAngle + TwoPI / 2, part.endingAngle, true)
      self.context.fill()
      self.context.moveTo(Z1.x, Z1.y)
      self.context.lineTo(Z2.x, Z2.y)

      self.context.stroke()
      self.context.restore()

      part.hX = location.x
      part.hY = location.y
      part.hRad = radius
    }
  }

  Corrected (input) {
    let val = parseFloat(input + '')
    if (val < 0) {
      val = TwoPI - Math.abs(val)
    }
    if (val > TwoPI) {
      val = val - TwoPI
    }
    return val
  }

  DrawMovingHandle (id, radius, hover) {
    const self = this
    const part = self.parts.find(r => r.id === id)
    if (part !== undefined) {
      let start = part.startingAngle
      let end = part.endingAngle

      if (end < start) {
        end = end + TwoPI
      }

      const half = Math.abs((end - start) / 2)
      let angle1 = part.startingAngle + half
      angle1 = self.Corrected(angle1)
      // angle1 = part.endingAngle
      // console.log(`${part.color} s: ${part.startingAngle} e: ${part.endingAngle} half: ${half} angle1: ${angle1} angle2: ${angle2}`)

      const add = hover ? 7 : 5
      let location = self.PolarToCartesian(angle1, radius + 0)

      self.context.save()
      self.context.translate(self.centerX(), self.centerY())
      self.context.fillStyle = part.color // hover ? '#35ae4c' : part.color

      self.context.beginPath()
      self.context.arc(location.x, location.y, add, 0, TwoPI, true)
      self.context.fill()
      self.context.stroke()
      self.context.restore()

      part.hiX = location.x
      part.hiY = location.y
      part.hiRad = add
    }
  }

  DrawCircle (radius) {
    const self = this
    self.context.save()
    self.context.moveTo(self.centerX(), self.centerY())
    self.context.beginPath()
    self.context.fillStyle = '#FFFFFF'
    self.context.arc(self.centerX(), self.centerY(), radius, 0, TwoPI, true)
    self.context.fill()
    self.context.stroke()
    self.context.restore()
  }

  GetMouseLocation (evt) {
    const self = this
    if (evt.clientX) {
      return {
        x: evt.clientX - self.rect.left,
        y: evt.clientY - self.rect.top
      }
    } else {
      return {
        x: evt.targetTouches[0].clientX - self.rect.left,
        y: evt.targetTouches[0].clientY - self.rect.top
      }
    }
  }

  TouchStart (event) {
    const self = this
    const target = self.GetTarget(self.GetMouseLocation(event))
    if (target.item !== undefined) {
      self.targetType = target.type
      self.draggedPart = target.item
      self.draggedNextNeighbour = self.parts.find(r => r.id === target.item.id + 1)
      self.draggedPreviousNeighbour = self.parts.find(r => r.id === target.item.id - 1)

      // last element, so next is first element in array
      if (self.draggedNextNeighbour === undefined) {
        self.draggedNextNeighbour = self.parts[0]
      }
      // first element, so previous is last element in array
      if (self.draggedPreviousNeighbour === undefined) {
        self.draggedPreviousNeighbour = self.parts[self.parts.length - 1]
      }
      // console.log(`dragged: ${JSON.stringify(self.draggedPart.id)} previous: ${self.draggedPreviousNeighbour.id} next: ${self.draggedNextNeighbour.id}`)
      // console.table(JSON.parse(JSON.stringify(self.parts)))
    }
  }

  TouchEnd () {
    const self = this
    if (self.draggedPart !== undefined) {
      self.targetType = undefined
      self.draggedPart = undefined
      self.draggedPreviousNeighbour = undefined
      self.draggedNextNeighbour = undefined
      // self.ReDraw()
    }
  }

  // CalcPartsDebug () {
  //   const self = this
  //   let result = self.CalcParts()
  //   return result
  //   // if (result === false) {
  //   //   for (let i = 0; i < self.parts.length; i++) {
  //   //     const currentItem = self.parts[i]
  //   //
  //   //     while (currentItem.startingAngle < 0) {
  //   //       currentItem.startingAngle = TwoPI + currentItem.startingAngle
  //   //     }
  //   //     while (currentItem.endingAngle < 0) {
  //   //       currentItem.endingAngle = TwoPI + currentItem.endingAngle
  //   //     }
  //   //     let diff = currentItem.endingAngle - currentItem.startingAngle
  //   //     // if (diff < 0) {
  //   //     //   diff = diff + TwoPI
  //   //     // }
  //   //     while (diff < 0) {
  //   //       diff = diff + TwoPI
  //   //     }
  //   //     currentItem.percent = Math.abs(parseFloat((diff / percent).toFixed(2)))
  //   //     console.log(`item: ${currentItem.id} diff: ${diff} percent: ${currentItem.percent} s: ${currentItem.startingAngle} e: ${currentItem.endingAngle} e-s: ${currentItem.endingAngle - currentItem.startingAngle}`)
  //   //   }
  //   // }
  //   // const totalPercent = self.parts.map(r => r.percent).reduce((a, b) => a + b)
  //   // console.log(`totalPercent: ${totalPercent}`)
  //   // return totalPercent === 100
  //
  //   // for (let i = 0; i < self.parts.length; i++) {
  //   //   const currentItem = self.parts[i]
  //   //
  //   //   if (currentItem.startingAngle < 0) {
  //   //     currentItem.startingAngle = TwoPI + currentItem.startingAngle
  //   //   }
  //   //   let diff = currentItem.endingAngle - currentItem.startingAngle
  //   //   if (diff < 0) {
  //   //     diff = diff + TwoPI
  //   //   }
  //   //   currentItem.percent = Math.abs(parseFloat((diff / percent).toFixed(2)))
  //   //   if (currentItem.percent < 1 || currentItem.percent > 100) {
  //   //     return false
  //   //   }
  //   // }
  //   // const totalPercent = self.parts.map(r => r.percent).reduce((a, b) => a + b)
  //   // // console.log(`totalPercent: ${totalPercent.toFixed(2)} totalPercent === 100: ${totalPercent === 100}`)
  //   // return totalPercent === 100
  // }

  CalcParts () {
    const self = this
    for (let i = 0; i < self.parts.length; i++) {
      const currentItem = self.parts[i]

      while (currentItem.startingAngle < 0) {
        currentItem.startingAngle = TwoPI + currentItem.startingAngle
      }
      while (currentItem.endingAngle < 0) {
        currentItem.endingAngle = TwoPI + currentItem.endingAngle
      }
      let diff = currentItem.endingAngle - currentItem.startingAngle
      while (diff < 0) {
        diff = diff + TwoPI
      }
      currentItem.percent = parseFloat((diff / percent).toFixed(2))
      if (currentItem.percent === 0 || currentItem.percent > 100) {
        return false
      }
    }
    const totalPercent = self.parts.map(r => r.percent).reduce((a, b) => a + b)
    // console.log(`totalPercent: ${totalPercent.toFixed(2)} totalPercent === 100: ${totalPercent === 100}`)
    return totalPercent === 100
  }

  TouchMove (event) {
    const self = this
    if (self.draggedPart === undefined) {
      const target = self.GetTarget(self.GetMouseLocation(event))
      if (target.item !== undefined) {
        if (target.type === 0) {
          target.item.hHovered = true
        }
        if (target.type === 1) {
          target.item.hiHovered = true
        }
        self.ReDraw()
      } else {
        let reDrawRequired = false
        self.parts.map(function (item) {
          if (item.hHovered === true) {
            item.hHovered = false
            reDrawRequired = true
          }
          if (item.hiHovered === true) {
            item.hiHovered = false
            reDrawRequired = true
          }
        })
        if (reDrawRequired) {
          self.ReDraw()
        }
        self.ReDraw()
      }
    } else {
      const geometry = self.GetGeometry()
      const location = self.GetMouseLocation(event)
      const dx = location.x - geometry.centerX
      const dy = location.y - geometry.centerY
      let newAngle = Math.atan2(dy, dx)

      if (newAngle < 0) {
        newAngle = (TwoPI - Math.abs(newAngle))
      }
      const originalStart = parseFloat(self.draggedPart.startingAngle + '')
      const originalEnd = parseFloat(self.draggedPart.endingAngle + '')
      const originalNeighbourEnd = parseFloat(self.draggedPreviousNeighbour.endingAngle + '')

      if (newAngle % percent !== 0) {
        newAngle = Math.floor(newAngle / percent) * percent
      }

      if (self.targetType === 0) {
        self.draggedPart.endingAngle = newAngle
        self.draggedNextNeighbour.startingAngle = newAngle
      }
      if (self.targetType === 1) {
        let end = originalEnd
        if (originalEnd < originalStart) {
          end = end + TwoPI
        }
        const originalHalf = Math.abs((end - originalStart) / 2)
        const newHalf = end - newAngle
        let delta = originalHalf - newHalf

        if (delta % percent !== 0) {
          delta = Math.floor(delta / percent) * percent
        }

        self.draggedPart.endingAngle = originalEnd + delta
        self.draggedNextNeighbour.startingAngle = self.draggedPart.endingAngle
        self.draggedPart.startingAngle = self.draggedPart.startingAngle + delta
        self.draggedPreviousNeighbour.endingAngle = self.draggedPart.startingAngle
      }
      if (self.CalcParts() === false) {
        self.draggedPart.endingAngle = originalEnd
        self.draggedNextNeighbour.startingAngle = originalEnd

        self.draggedPart.startingAngle = originalStart
        self.draggedPreviousNeighbour.endingAngle = originalNeighbourEnd
      }
      self.ReDraw()
    }
  }

  GetTarget (targetLocation) {
    const self = this
    const geometry = self.GetGeometry()

    const dx = targetLocation.x - geometry.centerX
    const dy = targetLocation.y - geometry.centerY

    const delta = 5
    const dragged = self.parts.find(r => (Math.abs(r.hX - dx)) < delta && (Math.abs(r.hY - dy) < delta))
    if (dragged === undefined) {
      const moving = self.parts.find(r => (Math.abs(r.hiX - dx)) < delta && (Math.abs(r.hiY - dy) < delta))
      return {
        type: 1,
        item: moving
      }
    }
    return {
      type: 0,
      item: dragged
    }
  }

  ClearAll () {
    const self = this
    self.context.clearRect(0, 0, self.canvas.width, self.canvas.height)
  }
}



// WEBPACK FOOTER //
// ./src/components/PChart.js